import EmptyBlock from "./EmptyBlock";

export default EmptyBlock;
